import { createAction, props } from '@ngrx/store';
import { Environment } from '@qvs/core';
import { ConfigurationEnum } from '@environments/IEnvironment';

export const loadEnvironment = createAction('[Env] Load environment', props<{ environmentConfiguration: ConfigurationEnum }>());

export const loadMockEnvironment = createAction(
  '[Env] Load mock environment',
  props<{ mockType: ConfigurationEnum.MOCK_CLIENT | ConfigurationEnum.MOCK_CRM_USER }>()
);

export const loadEnvironmentSuccess = createAction('[Env] Load environment success', props<{ environment: Environment }>());

export const loadEnvironmentFailure = createAction('[Env] Load environment failure');

export const networkConnectionOn = createAction('[App] network connection online');

export const networkConnectionOff = createAction('[App] network connection offline');
